// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useState, useMemo } from "react";
// Types
import { ChartSetSeven } from "../Libs/Types/ChartTypes";
// Utils
import {
  chartColors,
  CHART_AXIS_FALLBACK,
  humanize,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Compnents
import ChartFallBack from "../UI-Components/ChartFallback";

export default function HistogramChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetSeven["HistogramChart"];
  dataKey: string;
}) {
  // const yData = [5, 8, 24, 16, 32, 42, 30, 17, 11];
  // Assign a unique color to this chart instance ONCE
  const [chartColor] = useState(() => chartColors);

  // If you have multi-series, you can generate a list of random colors ONCE per chart
  const colorList = useMemo(() => {
    if (!chartData || !Array.isArray(chartData["data"][0]?.data)) return [];
    return chartData["data"][0].data.map(() => chartColors);
  }, [chartData]);
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    plotOptions: {
      bar: {
        columnWidth: "95%",
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    fill: {
      colors: colorList.length > 0 ? colorList : [chartColor], // Use colorList for multi-series, or chartColor for single
      opacity: 0.7,
    },
    colors: colorList.length > 0 ? colorList : [chartColor], // Also set here for line/area color[2][3]
    stroke: {
      width: 2,
      colors: ["#ee8080"],
    },
    dataLabels: { enabled: false },
    grid: {
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      type: "numeric",
      min: 0,
      // max: yData.length,
      // tickAmount: yData.length,
      labels: {
        formatter: (x) => x /*Math.round(x)*/,
        style: {
          fontSize: "8px",
        },
      },
      // title: { text: "Hours", offsetY: 70 },
      axisBorder: {
        show: true,
        color: "#ffff00",
      },
      title: {
        text:
          chartData !== undefined
            ? humanize(chartData["data"][0]["xaxis"])
            : CHART_AXIS_FALLBACK["x"],
      },
    },
    tooltip: {
      y: {
        title: {
          formatter: function (seriesName) {
            return humanize(seriesName);
          },
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
      title: {
        text:
          chartData !== undefined
            ? humanize(chartData["data"][0]["yaxis"])
            : CHART_AXIS_FALLBACK["y"],
      },
      // min: 0,
      // max: Math.max(...yData),
      axisBorder: {
        show: true,
        color: "#ff00ff",
      },
    },
  };

  const series: any =
    chartData !== undefined &&
    Array.isArray(chartData["data"][0]["data"]) === true
      ? chartData["data"][0]["data"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined ? (
        <ApexChart
          type="bar"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
